import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    title:
      '<b>Contribute</b> to <b>Match</b>ain and <b>earn rewards</b> by staking {token}',
    total: '{token} staked in total',
    apy: 'APY',
    upTo: 'Up to {apy}%',
    activeValidators: 'Active validators',
  },
};
